<template>
    <DashboardLayout :user="user">
        <div class="border border-gray-300 bg-white rounded-lg shadow-lg max-w-4xl mx-auto pb-10">
            
            <div class="bg-gray-200 text-lg font-semibold px-6 py-3 rounded-t-lg text-left">
                My Profile
            </div>

            <div class="px-6 py-4 flex space-x-4">
                <button 
                    class="px-6 py-2 rounded-full shadow-md font-semibold"
                    :class="activeTab === 'accountDetails' ? 'bg-primary text-white' : 'bg-gray-300 text-gray-700'"
                    @click="navigateTo('accountDetails')">
                    Account Details
                </button>
                <button 
                    class="px-6 py-2 rounded-full shadow-md font-semibold"
                    :class="activeTab === 'updateProfile' ? 'bg-primary text-white' : 'bg-gray-300 text-gray-700'"
                    @click="navigateTo('updateProfile')">
                    Change Password
                </button>
            </div>

            <div v-if="activeTab === 'accountDetails'">
                <AccountDetails :user="user" />
            </div>
            <div v-else-if="activeTab === 'updateProfile'">
                <UpdateProfile :user="user" />
            </div>

            
        </div>
    </DashboardLayout>

</template>

<script>


import DashboardLayout from "@/components/DashboardLayout.vue";
import AccountDetails from "./AccountDetails.vue";
import UpdateProfile from "./UpdateProfile.vue";
export default {
    name: 'MyProfile',
    components: {
        DashboardLayout, AccountDetails, UpdateProfile
    },
    data() {
        return {
            user: {},
            activeTab: 'accountDetails'
        };
    },
    computed:{
        currentComponent(){
            return this.activeTab == 'accountDetails' ? 'AccountDetails' : 'UpdateProfile';
        }
    },
    created() {
        const userData = localStorage.getItem('user');
        if (!userData) {
            alert("Session expired. Please log in again.");
            this.$router.push("/");
            return;
        }
        this.user = JSON.parse(userData);

        this.activeTab = "accountDetails";
        if (this.$route.path === "/update-profile") this.activeTab = "updateProfile";
        else this.activeTab = "accountDetails";
    },
    watch: {
        // Watch for URL changes and update the active tab
        "$route.path"() {
            this.updateTabFromRoute();
        }
    },
    methods: {
        navigateTo(tab) {
            this.activeTab = tab;
            const routes = {
                accountDetails: "/account-details",
                updateProfile: '/update-profile'
            };
            this.$router.push(routes[tab]);
        },
        updateTabFromRoute() {
            if (this.$route.path === "/update-profile") {
                this.activeTab = "updateProfile";
            } else {
                this.activeTab = "accountDetails";
            }
        }
        
    }
}

</script>
